module.exports = __webpack_public_path__ + "static/media/slevomat.5890eec0.jpg";